export default "__VITE_ASSET__rGVTtAVF__"